import React, { useState } from "react";
import { IconEye, IconEyeOff } from "@tabler/icons-react";

export default function BiometricConfig() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="space-y-4 border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] mb-4 mx-auto max-w-3xl mt-2">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-medium text-[#212121]">Biometric Configuration</h2>
      </div>
      
      <div className="bg-[#FFFFFF] p-6 rounded-lg space-y-6 border border-[#D2D2D2]">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-sm font-medium text-[#212121] mb-2">
              Corporate ID
            </label>
            <input
              type="text"
              defaultValue="Tbalar1121"
              className="w-full px-4 py-2.5 bg-gray-50/50 border border-gray-200 rounded-lg outline-none focus:ring-1 focus:ring-[#FBD037] text-[#212121]"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#212121] mb-2">
              Username
            </label>
            <input
              type="text"
              defaultValue="Tbalar1121"
              className="w-full px-4 py-2.5 bg-gray-50/50 border border-gray-200 rounded-lg outline-none focus:ring-1 focus:ring-[#FBD037] text-[#212121]"
            />
          </div>
        </div>

        <div className="mb-8">
          <label className="block text-sm font-medium text-[#212121] mb-2">
            Password
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="w-5 h-5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <input
              type={showPassword ? "text" : "password"}
              defaultValue="password123"
              className="w-full pl-10 pr-10 py-2.5 border border-gray-200 rounded-lg outline-none focus:ring-1 focus:ring-[#FBD037] text-[#212121]"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
            >
              {showPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
            </button>
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button className="bg-[#FBD037] text-[#212121] text-sm font-semibold px-5 py-2 rounded-full">
            Save Settings
          </button>
          <button className="border border-[#D2D2D2] text-[#212121] text-sm font-semibold px-5 py-2 rounded-full hover:bg-gray-50">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
